import React, { useEffect, useState } from "react";
import { Search, Film } from "lucide-react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { PageContainer, PageHeader, EmptyState } from "@/components/Page";

const filters = ["all", "draft", "generating", "ready", "published"];

const MyVideos = () => {
  const [videos, setVideos] = useState([]);
  const [filter, setFilter] = useState("all");
  const [q, setQ] = useState("");

  useEffect(() => { api.get(`/social/my-videos?status=${filter}`).then(({ data }) => setVideos(data.videos || [])).catch(() => {}); }, [filter]);

  const filtered = videos.filter((v) => !q || (v.title || v.topic || "").toLowerCase().includes(q.toLowerCase()));

  return (
    <PageContainer>
      <PageHeader title="My Videos" subtitle="All videos you've submitted or generated." testId="my-videos-header" />
      <div className="flex flex-wrap items-center gap-3 mb-6">
        <div className="flex-1 min-w-[200px] relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={16} />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search videos..." className="op-input pl-9" data-testid="my-videos-search" />
        </div>
        <div className="flex gap-2">
          {filters.map((f) => (
            <button key={f} onClick={() => setFilter(f)} className={filter === f ? "op-pill-active" : "op-pill-inactive"} data-testid={`filter-${f}`}>{f.charAt(0).toUpperCase() + f.slice(1)}</button>
          ))}
        </div>
      </div>
      {filtered.length === 0 ? (
        <div className="op-card"><EmptyState icon={Film} title="No videos found" description="Create your first AI video to see it here." action={<Link to="/video-factory/new" className="op-btn-primary">Create Video →</Link>} /></div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {filtered.map((v) => (
            <Link to={`/video-factory/new/${v.id}`} key={v.id} className="op-card overflow-hidden hover:border-[#7C3AED]">
              <div className="aspect-video bg-gray-100">{v.thumbnails?.[0] && <img src={v.thumbnails[0]} alt="" className="w-full h-full object-cover" />}</div>
              <div className="p-3">
                <p className="text-sm font-medium text-gray-900 truncate">{v.title || v.topic}</p>
                <p className="text-xs text-gray-500 capitalize">{v.status}</p>
              </div>
            </Link>
          ))}
        </div>
      )}
    </PageContainer>
  );
};
export default MyVideos;
